import { render, staticRenderFns } from "./RemoveStaffPopup.vue?vue&type=template&id=1f06bf32&scoped=true&"
import script from "./RemoveStaffPopup.vue?vue&type=script&lang=ts&"
export * from "./RemoveStaffPopup.vue?vue&type=script&lang=ts&"
import style0 from "./RemoveStaffPopup.vue?vue&type=style&index=0&id=1f06bf32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f06bf32",
  null
  
)

export default component.exports